import React from 'react'
import lang from '@/lang'
import { makeStyles, useTheme } from '@mui/styles'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconExclamationMark from '@assets/images/icons/mahnen.svg'
import PerfectScrollbar from 'react-perfect-scrollbar'
import ButtonIconSquare from '@/modules/base/components/buttons/icon-square/button-icon-square'
import { Title } from '@/modules/base/components/texts'
import { useNavigate } from 'react-router'

const DuplicatedCustomerEmails = (props) => {
  const navigate = useNavigate()
  const { syncDetails: { duplicatedCustomers } } = props
  const { cleverreach: cleverreachLang } = lang
  const theme = useTheme()
  const classes = useStyles()

  return (
    <div className={classes.duplicatesWrapper}>
      <div>
        <SVGIcon svg={IconExclamationMark} height='126px' width='126px' className={classes.exlamationMark} fill={theme.primary} />
      </div>
      <Title size='large' marginBottom='30px' position='center' fontWeight='mediumbold'>{cleverreachLang.duplicatesTitle} </Title>
      <div className={classes.duplicatesSubtitle}>{cleverreachLang.duplicatesSubtitle}</div>
      <div className={classes.listWrapper}>
        <PerfectScrollbar >
          <div className={classes.scrollContainer}>
            {duplicatedCustomers.map((customer, index) => {
              return (
                <div key={index} className={classes.listRow}>
                  <div className={classes.spaceBetween}>
                    <SVGIcon svg={IconExclamationMark} height='16px' fill={theme.blue} />
                    <div className={classes.emailItem}> {customer.email} </div>
                  </div>
                  <div className={classes.customerNumber}>
                    {lang.customer.model.customerNumberAbbreviation + ' ' + customer.inCustomers.join(', ')}
                  </div>
                </div>
              )
            })}
          </div>
        </PerfectScrollbar>
      </div>
      <ButtonIconSquare variant='outline' className={classes.goToCustomersButton} onClick={() => navigate('/customers')}>
        {cleverreachLang.buttonTextEditCustomerData}
      </ButtonIconSquare>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  emailItem: {
    marginLeft: 8,
    display: 'flex',
    flexDirection: 'row',
  },
  exlamationMark: {
    marginBottom: 40,
  },
  customerNumber: {
    ...theme.mixins.truncateText,
  },
  duplicatesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.white,
    width: 700,
  },
  duplicatesSubtitle: {
    marginBottom: 24,
    fontSize: 15,
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'right',
  },
  listRow: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.borderColor}`,
    padding: '14px 0',
  },
  listWrapper: {
    height: 218,
    width: 612,
    borderRadius: 6,
    backgroundColor: theme.backgroundColor,
    border: `1px solid ${theme.borderColor}`,
    margin: '0 auto',
    textAlign: 'left',
    overflow: 'hidden',
  },
  scrollContainer: {
    padding: '16px 40px',
  },
  list: {
    maxHeight: 360,
    width: 612,
    borderRadius: 6,
    backgroundColor: theme.backgroundColor,
    border: `1px solid ${theme.borderColor}`,
    margin: '0 auto',
    padding: '0 0 50px 40px',
    textAlign: 'left',
    overflow: 'hidden',
  },
  goToCustomersButton: {
    width: 205,
    margin: '30px auto',
  },
}))

export default DuplicatedCustomerEmails
